export default __webpack_public_path__ + "static/media/doctor.c4710f11.png";